import { InjectionToken } from '@angular/core';

export const PROVIDE_USER_TYPE = new InjectionToken('VIEWER TYPE');
export const IS_PHOTOGRAPHER = new InjectionToken('IS PHOTOGRAPHER');

export enum ViewerType {
  photographer = 'photographer',
  lbMaestro = 'lbMaestro',
  ordersManager = 'OrdersManager',
  retouchManager = 'RetouchManager',
  retoucher = 'Retoucher',
  campaignManager = 'CampaignManager',
  supportAgent = 'Support',
  client = 'Client',
  labManager = 'LabManager',
  labOutsource = 'LabOutsource',
  lab = 'Lab',
  labEmployee = 'LabEmployee',
  competitionMember = 'CompetitionMember',
}
